import { useSyncExternalStore } from "react";

/**
 * Bandeau de mise à jour de la PWA. Quand un nouveau service worker est prêt, l'utilisateur est
 * informé et déclenche lui-même le rechargement — plutôt qu'une mise à jour silencieuse qui
 * laisserait les onglets ouverts sur l'ancien bundle (cahier des charges §16, gestion explicite de
 * la mise à jour). L'état vit dans un petit store externe alimenté par le hook d'enregistrement du
 * service worker (main.tsx).
 */

let reload: (() => void) | null = null;
let needRefresh = false;
const listeners = new Set<() => void>();

/** Signale qu'une nouvelle version est prête ; `doReload` applique la mise à jour et recharge. */
export function signalNeedRefresh(doReload: () => void): void {
  reload = doReload;
  needRefresh = true;
  listeners.forEach((l) => l());
}

function subscribe(cb: () => void): () => void {
  listeners.add(cb);
  return () => listeners.delete(cb);
}
function getSnapshot(): boolean {
  return needRefresh;
}

export function UpdateBanner() {
  const show = useSyncExternalStore(subscribe, getSnapshot);
  if (!show) return null;
  return (
    <div className="update-banner" role="status">
      <span>Une nouvelle version de Pensieve est disponible.</span>
      <button className="update-banner-btn" onClick={() => reload?.()}>
        Recharger
      </button>
    </div>
  );
}
